(function () {
    const $body = $('body');

    const searchResult = {
        url: location.href,
        rememberUserLayout: true,
        /**
         * The saved search panel
         */
        $savedSearchPanel: null,
        /**
         * Frequency Column Labels
         */
        frequencyLabels: {},
        /**
         * The max search queries needed to for iteration over the table
         */
        maxSearchQueries: null,
        /**
         * Link to edit saved search item
         */
        goLink: '/action/doSearch?target=saved&runSaved=',
        /**
         * Link to remove saved search item
         */
        removeLink: '/action/doDeleteSearch?searchType=saved&queryId=',
        init() {
            //searchResult.get.url();
            this.$savedSearchPanel = $('.advancedSearch__tabs .saved-searches');
            this.maxSearchQueries = this.$savedSearchPanel.data('queries');
            this.frequencyLabels = this.$savedSearchPanel.data('frequency-labels');

            searchResult.control();
            searchResult.additionalInit();
            searchResult.additionalControl();
            searchResult.set.userPublicationLayout();
        },
        control: function () {
            $body.on('click', '#saveSearchTriggerButton', function () {
                searchResult.openSaveSearchDialog();
            });

            $body.on('submit', '#saveSearchDialog form', function (event) {
                return searchResult.onSaveSearchSubmitHandler(event);
            });

            $body.on('click', '.search__layout>span', function () {
                $('.search__layout>span').removeClass('active');
                $(this).addClass('active');

                if ($(this).hasClass('search__layout-tile')) {
                    $('.search-result__body').addClass('search-result--tile');
                    localStorage.setItem('userPublicationLayout', 'tile');
                } else {
                    $('.search-result__body').removeClass('search-result--tile');
                    localStorage.setItem('userPublicationLayout', 'list');
                }
            });
            $body.on('focus', '[name="AllField"]', function (e) {
                const allFieldInput = $(e.currentTarget);
                if (allFieldInput.length) {
                    allFieldInput[0].setSelectionRange(-1, -1);
                }
            });
        },
        additionalControl: function () {},
        additionalInit: function () {},
        set: {
            userPublicationLayout: function () {
                if (searchResult.rememberUserLayout) {
                    if (localStorage.userPublicationLayout === 'tile') {
                        $('.search__layout-tile').click();
                    } else if (localStorage.userPublicationLayout === 'list') {
                        $('.search__layout-list').click();
                    }
                }
            },
        },
        get: {
            url: function () {},
            text: function (name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); /*eslint-disable-line*/
                const regexS = '[\\?&]' + name + '=([^&#]*)';
                const regex = new RegExp(regexS);
                const results = regex.exec(searchResult.url);
                return results == null ? null : results[1];
            },
            value: function () {},
        },
        /**
         * Responsible for rendering row items
         */
        render: {
            /**
             * Responsible for rendering rows
             *
             * @param {object} item
             * @param {number} index
             */
            row(item, index) {
                const $row = searchResult.$savedSearchPanel.find('tbody tr').eq(index);
                this.columns($row, item);
                this.actions($row, item);
                if ($row.hasClass('hidden')) {
                    $row.removeClass('hidden');
                    searchResult.$savedSearchPanel.find('.table-responsive').parent().removeClass('hidden');
                    searchResult.$savedSearchPanel.find('.emptySavedSearches').remove();
                }
            },
            /**
             * Responsible for rendering columns
             *
             * @param {jQuery} $row
             * @param {object} item
             */
            columns($row, item) {
                const {qName, qSavedOn, qLastRun} = item;
                $row.find('.name-td').html(qName);
                $row.find('.saved-on-td').html(qSavedOn);
                $row.find('.last-run-td').html(qLastRun);
                this.additionalColumns($row, item);
                this.frequencyColumn($row, item);
            },

            /**
             * Responsible for additional columns rendering,
             * can be used to modify rendered row columns
             *
             * @param {jQuery} $row
             * @param {object} item
             */
            additionalColumns($row, item) {},
            /**
             * Render Frequency Column
             *
             * @param {jQuery} $row
             * @param {string} qAlertStatus
             */
            frequencyColumn($row, {qAlertStatus}) {
                let frequency = qAlertStatus;
                if (searchResult.frequencyLabels && searchResult.frequencyLabels[frequency]) {
                    frequency = searchResult.frequencyLabels[frequency];
                }
                $row.find('.frequency-td').html(frequency);
            },
            /**
             * Responsible for rendering action columns
             *
             * @param {jQuery} $row
             * @param {number} qId
             */
            actions($row, {qId}) {
                $row.find('[data-action-type="saved-search--remove"]').attr('href', searchResult.removeLink + qId);
                $row.find('[data-action-type="saved-search--run"]').attr('href', searchResult.goLink + qId);
            },
        },
        openSaveSearchDialog: function () {
            var openDialog = searchResult.getCookie('openDialog');
            if (openDialog != null && openDialog !== '') {
                const saveSearchButton = $('#saveSearchTriggerButton');
                if (saveSearchButton.length > 0) {
                    document.cookie = 'openDialog=;expires=Wed; 01 Jan 1970';
                    saveSearchButton.click();
                }
            }
        },
        getCookie: function (name) {
            const nameEQ = name + '=';
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1);
                if (c.indexOf(nameEQ) !== -1) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        onSaveSearchSubmitHandler: function (e) {
            $('#newSearchSaveButton').hide();
            $('.saveSearchProgress').show();
            $.ajax({
                type: 'POST',
                url: '/action/doSaveSearch',
                data: $(e.target).serialize(),
                success: searchResult.saveSearchSuccessHandler,
                error: function (data) {
                    $('.error.saveSearchMsg').show('fade').removeClass('hidden');
                    $('#newSearchSaveButton').show();
                    $('.success.saveSearchMsg, .saveSearchProgress').hide();
                    $('#saveSearchDialog').modal('toggle');
                    $('#saveSearchDialog').click();
                },
            });
            return false;
        },
        saveSearchSuccessHandler: function (data) {
            $('.success.saveSearchMsg').show('fade').removeClass('hidden');
            $('#newSearchSaveButton').show();
            $('.error.saveSearchMsg, .saveSearchProgress').hide();
            $('#saveSearchDialog').modal('toggle');
            $('#saveSearchDialog').click();
            UX.modal.on.hide();
            searchResult.redrawSavedSearchesPanel(JSON.parse(data).favQueries);
        },

        /**
         * Redraws the table rows using the incoming from favQueries
         *
         * @param {array} jsonData
         */
        redrawSavedSearchesPanel(jsonData) {
            jsonData.forEach((value, index) => {
                if (index >= searchResult.maxSearchQueries) {
                    return;
                }
                this.render.row(value, index);
            });
        },
    };
    UX.searchResult = searchResult; // add to global namespace
})();
